/**
 * マッチング設定一覧ページ コンテナ
 */

import {
  useActivateMatchingCondition,
  useDeactivateMatchingCondition,
  useDeleteMatchingCondition,
  useMatchingConditions,
} from "hooks/use-matching-conditions-api";
import type React from "react";
import { useCallback } from "react";
import { MatchingConditionsPage } from "routes/settings/MatchingConditionsPage/MatchingConditionsPage";

const MatchingConditionsPageContainer: React.FC = () => {
  const { settings, loading, error, refetch } = useMatchingConditions();
  const { activateSetting, loading: isActivating } =
    useActivateMatchingCondition();
  const { deactivateSetting, loading: isDeactivating } =
    useDeactivateMatchingCondition();
  const { deleteSetting, loading: isDeleting } = useDeleteMatchingCondition();

  const handleActivate = useCallback(
    async (settingId: string) => {
      await activateSetting(settingId);
      await refetch();
    },
    [activateSetting, refetch],
  );

  const handleDeactivate = useCallback(
    async (settingId: string) => {
      await deactivateSetting(settingId);
      await refetch();
    },
    [deactivateSetting, refetch],
  );

  const handleDelete = useCallback(
    async (settingId: string) => {
      await deleteSetting(settingId);
      await refetch();
    },
    [deleteSetting, refetch],
  );

  return (
    <MatchingConditionsPage
      settings={settings}
      loading={loading}
      error={error ? { message: error.message } : null}
      onActivate={handleActivate}
      onDeactivate={handleDeactivate}
      onDelete={handleDelete}
      isActivating={isActivating || isDeactivating}
      isDeleting={isDeleting}
    />
  );
};

export default MatchingConditionsPageContainer;
